import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { NavigationButton } from '../buttons/NavigationButton';

export interface IDatePickerProps {
  canClickNext: boolean;
  canClickPrevious: boolean;
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
  onSetDate: (date: Date) => Promise<void>;
  onClickNext: () => Promise<void>;
  onClickPrevious: () => Promise<void>;
}

export const DayPicker = observer((props: IDatePickerProps): ReactElement => {
  const { selectedDate, onSetDate, onClickNext, onClickPrevious, minDate, maxDate, canClickNext, canClickPrevious } = props;

  const [isOpen, setIsOpen] = useState(false);
  const toggle = (): void => {
    setIsOpen((prevState) => !prevState);
  };

  const onChange = async (date: Date | null): Promise<void> => {
    if (date) {
      await onSetDate(date);
      toggle();
    }
  };

  const renderLabel = (): ReactElement => (
    <div
      className='date-label-container'
      onClick={toggle}
    >
      <div>
        <label
          className='selected-date'
          onClick={toggle}
        >
          {selectedDate.toLocaleDateString()}
        </label>
      </div>
      <FontAwesomeIcon
        icon={isOpen ? faAngleUp : faAngleDown}
        onClick={toggle}
      />
    </div>
  );

  return (
    <div className='date-range-field'>
      <NavigationButton
        onClick={() => {
          void onClickPrevious();
        }}
        disabled={!canClickPrevious}
        left
      />
      <div>
        <ReactDatePicker
          minDate={minDate}
          maxDate={maxDate}
          selected={selectedDate}
          onChange={(date) => {
            void onChange(date);
          }}
          open={isOpen}
          customInput={renderLabel()}
          onBlur={toggle}
          onClickOutside={toggle}
          calendarStartDay={1}
          disabledKeyboardNavigation
        />
      </div>
      <NavigationButton
        onClick={() => {
          void onClickNext();
        }}
        disabled={!canClickNext}
      />
    </div>
  );
});
